<template>
  <button class="close-btn-ui" type="button">
    <div class="close-btn-ui__icon">
      <i class="fr fr-close"></i>
    </div>
  </button>
</template>
